"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

function langKey(key) {
  return "ComposeUI.header.ReadOnlyTooltip." + key;
}

var _default = (0, _createReactClass.default)({
  displayName: "ReadOnlyTooltip",
  propTypes: {
    centered: _propTypes.default.bool,
    presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
    showReadOnlyMode: _propTypes.default.bool,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  renderIcon: function renderIcon(centered) {
    if (!centered) {
      return null;
    }

    return _react.default.createElement(_UIIcon.default, {
      className: "m-right-2",
      name: "view",
      size: "xs"
    });
  },
  renderTooltipBody: function renderTooltipBody() {
    var messageKey = this.props.showReadOnlyMode ? 'tooltip.readOnlyBody' : 'tooltip.commentOnlyBody';
    return _react.default.createElement(_FormattedMessage.default, {
      message: langKey(messageKey)
    });
  },
  renderTooltipTitle: function renderTooltipTitle() {
    var _this$props = this.props,
        presence = _this$props.presence,
        showReadOnlyMode = _this$props.showReadOnlyMode,
        users = _this$props.users;

    var _parseUser = (0, _userHelpers.parseUser)(presence.locker, users),
        firstName = _parseUser.firstName,
        lastName = _parseUser.lastName;

    if (showReadOnlyMode) {
      return null;
    }

    return _react.default.createElement(_FormattedMessage.default, {
      message: langKey('tooltip.commentOnlyTitle'),
      options: {
        firstName: firstName,
        lastName: lastName
      }
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        centered = _this$props2.centered,
        showReadOnlyMode = _this$props2.showReadOnlyMode;

    if (!showReadOnlyMode) {
      return null;
    }

    var className = (0, _classnames.default)('m-left-2', {
      'read-only-tooltip-container-centered': centered
    });
    var headingKey = showReadOnlyMode ? 'readOnlyHeading' : 'commentOnlyHeading';
    return _react.default.createElement("div", {
      className: className
    }, this.renderIcon(centered), _react.default.createElement("strong", null, _react.default.createElement(_FormattedMessage.default, {
      message: langKey(headingKey)
    })), _react.default.createElement(_UITooltip.default, {
      className: "read-only-tooltip",
      headingText: this.renderTooltipTitle(),
      title: this.renderTooltipBody()
    }, _react.default.createElement(_UIIcon.default, {
      className: "m-left-2",
      color: _colors.EERIE,
      name: "info"
    })));
  }
});

exports.default = _default;
module.exports = exports.default;